module.exports = __webpack_public_path__ + "static/media/m-aquearium.a21d814e.png";